<template>
  <v-snackbar v-model="showError">
    {{ errorMessage }}

    <template v-slot:action="{ attrs }">
      <v-btn color="primary" text v-bind="attrs" @click="showError = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { TYPE_SET_ERROR_TOGGLE } from '../store/mutations';
export default {
  name: "hb-bab-snackbar",
  computed:{
      showError:{
          get(){
              return this.$store.state.showError;
          },
          set(value){
              this.$store.commit(TYPE_SET_ERROR_TOGGLE, value)
          }
      },
      errorMessage(){
          return this.$store.state.errorMessage;
      }
  }
};
</script>

<style>
</style>